import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { PrintType } from './printTypes';

interface TagPrintState {
  modalVisible: boolean;
  selectedTagId?: string;
  selectedTagNum?: string;
  autoPrint: boolean;
  printType: PrintType;
}

const initialState: TagPrintState = {
  modalVisible: false,
  selectedTagId: undefined,
  selectedTagNum: undefined,
  autoPrint: false,
  printType: 'tag_print',
};

export const tagPrintSlice = createSlice({
  name: 'tagPrint',
  initialState,
  reducers: {
    openTagPrintModal: (
      state,
      action: PayloadAction<{
        id?: string;
        tagNum?: string;
        autoPrint?: boolean;
        printType?: PrintType;
      }>,
    ) => {
      state.modalVisible = true;
      state.selectedTagId = action.payload.id;
      state.selectedTagNum = action.payload.tagNum;
      state.autoPrint = action.payload.autoPrint ?? false;
      state.printType = action.payload.printType ?? 'tag_print';
    },
    closeTagPrintModal: state => {
      state.modalVisible = false;
      state.selectedTagId = undefined;
      state.selectedTagNum = undefined;
      state.autoPrint = false;
      state.printType = 'tag_print';
    },
  },
});

export const { openTagPrintModal, closeTagPrintModal } = tagPrintSlice.actions;

export const tagPrintModalDataSelector = (state: { tagPrint: TagPrintState }) => state.tagPrint;

export default tagPrintSlice.reducer;
